import type { TEffectCallback } from './effect'

export interface IInitParams {
  url: string
}

export enum EJoinGameQuality {
  LOW,
  MEDIUM,
  HD,
  FULL_HD
}

export enum EJoinGamePlatform {
  MOBILE = 1,
  PC = 0
}

export enum EWSEventName {
  JOIN = '_join',
  OFFER = '_offer',
  CANDIDATE = '_candidate',
  PING = '_ping',
  FORCEI = '_forceI',
  AUDIO_MUTE = '_audio_mute',
  SWITCH_QUALITY = '_switch_quality'
}

export enum EWSEventType {
  CLIENT = '1',
  SERVER = '2'
}

export enum EWSHookName {
  JOIN_RES = '_join_res',
  ANSWER = '_answer',
  NOTIFY = '_notify',
  INPUT_STATUS = '_transmit'
}

export enum EVideoQuality {
  '360P' = 0,
  '480P' = 1,
  '720P' = 2,
  '1080P' = 3
}

export interface IJoinEventInputParams {
  uid: string;
  token: string;
  deviceId: number;
  phoneId: string;
  ip: string;
  gameInfo: {
    gameId: number,
    packageName: string,
    minutes: number
  }
}

export type IWsEffectCallback = <T>(callback: TEffectCallback<T>, effectList: Array<EWSHookName>, needEventName?: boolean) => void
export type IWsSend = <T>(eventName: EWSEventName, data: T) => void
